module.exports = __webpack_public_path__ + "img/page-load-loader.27cab8c2.gif";